import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import * as commonActions from './../../actions/commonActions';
import * as tradepanelActions from './../../actions/tradepanelActions';
import * as activityActions from './../../actions/activityActions';
import * as authActions from '../../redux/modules/auth';
import styles from './AlertComponent.less';
import appConstants from './../../appConstants';
import moment from 'moment';
import i18next from 'i18next';
import { applyStyle,applyToHover, setDirection } from './../../utils/utils';
import MUIIcon from '../../components/IconMaterialUI/MUIIcon';

const elementsData = [
  {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"closeBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
];

const directionData = [
  {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"commonCloseIcon","elementType":"normal", "applyTo":"single", "tagNames":"div"},
];

@connect(
  state => ({
    alertWindow:state.dashboardRoot.tradepanelReducer.alertWindow,
    benmFillObj:state.dashboardRoot.activityReducer.benmFillObj,
    lmtFillModExpObj:state.dashboardRoot.activityReducer.lmtFillModExpObj,
    //selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
    selectedLang:state.dashboardRoot.commonReducer.selectedLang
  }),
  {...commonActions,...authActions,...tradepanelActions,...activityActions}
)

export default class AlertComponent extends Component {
  static propTypes = {
    showAlert:PropTypes.object,
    benmFillObj:PropTypes.object,
    closeAlert:PropTypes.func.isRequired,
    closeBMAlert:PropTypes.func.isRequired,
  }

  state = {
    account_Name:'',
    template:'',
  };

  closeModal = () => {
    try{
      this.props.closeAlert();
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeModal', component:"AlertComponent"});
    }
  }

  closeBMModal=()=>{
    try{
      this.props.closeBMAlert(this.props.benmFillObj);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeBMModal', component:"AlertComponent"});
    }
  }

  render() {
    const CloseIcon = <MUIIcon icon={'Close'} className="dp48 closeBtn"/>;
    const time = new Date(this.props.alertWindow.TS);
    const dateFormate=appConstants.actTimeDateTimeFormatter;
    const msgTime=moment(time).format(dateFormate);
    // const header= Object.assign({},this.props.selectedCssColorTheme.header,this.props.selectedLang.header)

    return (
      <div id="alertCompMainDiv" className='container'>
        <Modal  isOpen={this.props.alertWindow.flag}  contentLabel={i18next.t('msgfrmDealer')} className={styles.alertContainer} id="alertModal" onAfterOpen={this.afterOpenModal}>
          <div ref="errorMSG" className={`${styles.mdlWrap} mdlWrap`}>
            <div className={`${styles.header} header`}>
              <span className={`${styles.msgTitle}`}>{this.props.alertWindow.label}</span>
              <span className={`${styles.closeImg} closeIcon`} onClick={this.closeModal} id="alrtCloseIcon" style={this.props.selectedLang.commonCloseIcon}>{CloseIcon}</span>
            </div>

            <div className={`${styles.msgDiv}`} style={this.props.selectedLang.commonMsgDir}>
              <textarea rows="7" className="form-control" value={this.props.alertWindow.MSG} readOnly />
            </div>

            <div className={`${styles.msgLabel}`} style={this.props.selectedLang.commonMsgDir}>
              <span>{msgTime}</span>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
